import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function HomeHeroSection() {
  return (
    <section className="min-h-screen relative flex items-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 z-0 pointer-events-none" style={{ position: 'fixed', top: 0, left: 0, right: 0, height: '100vh', zIndex: 0 }}>
        <img
          src="https://customer-assets.emergentagent.com/job_ai-architect-55/artifacts/ee4u2d28_R_Dale_Brunet_AI_2.jpg"
          alt="R. Dale Brunet"
          className="w-full h-full object-cover object-top opacity-80"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/60 to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 py-32 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
        <div className="max-w-2xl flex-1">
          <motion.span
            className="text-sm text-primary font-semibold uppercase tracking-[0.25em] mb-6 block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Practical AI for Real Businesses
          </motion.span>

          <motion.div
            className="flex items-center gap-4 md:gap-6 mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <img
              src="/assets/rdbrunet_logo.png"
              alt=""
              className="w-28 h-28 md:w-40 md:h-40 rounded-full object-cover flex-shrink-0"
              data-testid="hero-logo"
            />
            <h1
              className="text-5xl md:text-7xl font-bold tracking-tight text-white leading-none"
              data-testid="hero-headline"
            >
              R. Dale Brunet
            </h1>
          </motion.div>

          <motion.p
            className="text-lg md:text-xl text-primary/90 mb-4 font-medium"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            AI Workflow Architect | Automation Strategist | Entrepreneur
          </motion.p>

          <motion.p
            className="text-lg text-slate-300 max-w-xl mb-10 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            Designing practical systems that help people and organizations harness emerging technologies to improve how they work, create, and build the future. With decades of experience bridging the gap between complex technology and real-world application, I turn ambitious ideas into operational systems that deliver measurable results.
          </motion.p>

          <motion.div
            className="flex flex-wrap gap-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <Button asChild size="lg" className="bg-[#8899ff] text-white hover:text-white hover:bg-[#7788ee] px-6 shadow-[0_4px_0_0_rgba(100,120,200,1)] hover:shadow-[0_2px_0_0_rgba(100,120,200,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100" data-testid="hero-aiw-btn">
              <Link to="/ai-whisperer">AI Whisperer</Link>
            </Button>
            <Button asChild size="lg" className="bg-[#0a5a8a] text-white hover:text-white hover:bg-[#0d6da3] px-6 shadow-[0_4px_0_0_rgba(5,60,92,1)] hover:shadow-[0_2px_0_0_rgba(5,60,92,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100" data-testid="hero-hca-btn">
              <Link to="/hca">Human Continuity Architecture</Link>
            </Button>
            <Button asChild size="lg" className="bg-primary text-white hover:text-white hover:bg-primary/80 px-6 shadow-[0_4px_0_0_rgba(168,130,20,1)] hover:shadow-[0_2px_0_0_rgba(168,130,20,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100" data-testid="hero-services-btn">
              <Link to="/schedule">Services</Link>
            </Button>
            <Button asChild size="lg" className="bg-emerald-600 text-white hover:text-white hover:bg-emerald-500 px-6 shadow-[0_4px_0_0_rgba(5,100,73,1)] hover:shadow-[0_2px_0_0_rgba(5,100,73,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100" data-testid="hero-books-btn">
              <Link to="/books">Books</Link>
            </Button>
            <Button asChild size="lg" className="bg-amber-700 text-white hover:text-white hover:bg-amber-600 px-6 shadow-[0_4px_0_0_rgba(120,53,15,1)] hover:shadow-[0_2px_0_0_rgba(120,53,15,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100" data-testid="hero-chefbb-btn">
              <Link to="/chefbb">Chef BB</Link>
            </Button>
            <Button asChild size="lg" className="bg-rose-600 text-white hover:text-white hover:bg-rose-500 px-6 shadow-[0_4px_0_0_rgba(159,18,57,1)] hover:shadow-[0_2px_0_0_rgba(159,18,57,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100" data-testid="hero-speaking-btn">
              <Link to="/speaking">Speaking</Link>
            </Button>
            <Button asChild size="lg" className="bg-cyan-600 text-white hover:text-white hover:bg-cyan-500 px-6 shadow-[0_4px_0_0_rgba(14,100,131,1)] hover:shadow-[0_2px_0_0_rgba(14,100,131,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100" data-testid="hero-ventures-btn">
              <Link to="/ventures">Ventures</Link>
            </Button>
          </motion.div>
        </div>

        <motion.div
          className="flex flex-col items-center flex-shrink-0 mt-8 lg:mt-0"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_6ab5280f-8574-4593-a0f4-4545bb64e3a0/artifacts/od83qhhi_The_AI_Whisperer_Landscape_Promo_Image_New_Audia.jpg"
            alt="The AI Whisperer by R. Dale Brunet"
            className="w-96 md:w-[28rem] lg:w-[32rem] xl:w-[36rem] rounded-lg drop-shadow-[0_20px_40px_rgba(0,0,0,0.5)]"
            data-testid="hero-book-cover"
          />
          <a
            href="https://www.newaudia.com/player/7155523d-c8a5-4aa7-8235-a99b96ea7683"
            target="_blank"
            rel="noopener"
            className="mt-4 bg-primary text-white hover:text-white hover:bg-primary/80 px-6 py-2.5 rounded-md text-sm font-semibold shadow-[0_4px_0_0_rgba(168,130,20,1)] hover:shadow-[0_2px_0_0_rgba(168,130,20,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100 inline-block text-center"
            data-testid="hero-read-now-btn"
          >
            Listen Now on NewAudia.com
          </a>
          <a
            href="https://books.by/use-what-you-got-publishing/the-ai-whisperer"
            target="_blank"
            rel="noopener"
            className="mt-3 bg-slate-700 text-slate-200 border border-slate-500 hover:text-white hover:bg-slate-600 px-6 py-2.5 rounded-md text-sm font-semibold shadow-[0_4px_0_0_rgba(51,65,85,1)] hover:shadow-[0_2px_0_0_rgba(51,65,85,1)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] transition-all duration-100 inline-block text-center"
            data-testid="hero-order-paperback-btn"
          >
            Order Paperback Today
          </a>
        </motion.div>
        </div>
      </div>
    </section>
  );
}
